import { makeStyles } from '@mui/styles';

const styles = makeStyles((theme) => ({
  searchBar: {
    backgroundColor: 'transparent',
    width: '25vh',
    marginRight: '1vh',
    '&.MuiFilledInput-root:hover': {
      backgroundColor: 'transparent',
    },
    '&.MuiInputBase-root :hover': {
      backgroundColor: 'transparent',
    },
    fontSize: 'larger',
  },
  dateContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  runActionContainer: {
    marginLeft: '-8px'
  },
  aspectRatioContainer: {
    marginLeft: '-10px',
  },
  dateTimePicker: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    alignSelf: 'flex-start',
  },
}));

export default styles;
